(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CompanyRegistryService', CompanyRegistryService)

    /** @ngInject */
    function CompanyRegistryService(HttpService) {
        const CompanyRegistryService = {
            getByCnpj: getByCnpj
        }

        return CompanyRegistryService;

        /**
         * Consulta um CNPJ na Receita Federal pelo SSO (que fala com a BrasilAPI e guarda 24 h em cache).
         *
         * A rota NAO responde erro por causa do terceiro: indisponibilidade volta 200 com Outcome 'Unavailable'.
         * Os Outcome possiveis sao 'Found', 'NotFound', 'Invalid', 'Placeholder' e 'Unavailable', e vem junto um
         * 'Message' pronto para a tela (nulo quando nao ha nada a avisar).
         */
        function getByCnpj(cnpj) {
            const digitos = (cnpj || '').replace(/\D/g, '');

            return HttpService.get(`/company-registry/${digitos}`);
        }
    }
}());
